import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { memo, useMemo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import TransferOfChargeEditPanel from "./TransferOfChargeEditPanel";
import TransferOfChargeTablePanel from "./TransferOfChargeTablePanel";

const TransferOfChargeRightPanel = () => {
    const [transferOfChargeState] = useTransferOfChargeTracked();
    const { isShowEditPanel } = transferOfChargeState;

    const memoTransferOfChargeTable = useMemo(() => {
        return <TransferOfChargeTablePanel />
    }, [])

    const memoTransferOfChargeEditPanel = useMemo(() => {
        return <TransferOfChargeEditPanel />
    }, [])

    return <>
        <div className={`main-comp-wrapper${(isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>

            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowEditPanel ? "70%" : "100%"}
                rightSectionWidth={isShowEditPanel ? "30%" : "0%"}
                leftChildren={memoTransferOfChargeTable}
                rightChildren={memoTransferOfChargeEditPanel}
            />
        </div>
    </>
}

export default memo(TransferOfChargeRightPanel);